// extracted by mini-css-extract-plugin
export var autoExpand = "_2s-b";
export var container = "_2s-a";
export var containerWidth = "_2s-8";
export var disabled = "_2s-2";
export var error = "_2s-3";
export var fullWidth = "_2s-9";
export var highlightContainer = "_2s-5";
export var inputWrapper = "_2s-0";
export var small = "_2s-1";
export var textarea = "_2s-4";
export var validatedTextarea = "_2s-6";
export var visuallyHidden = "_2s-7";